// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".avatar[data-v-e14b73fc]{width:32px;height:32px;border-radius:32px;object-fit:cover;vertical-align:middle}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
